import React, { createContext, useContext, useState } from "react";
import { LoadingCtxType } from "../models/context";


const loadindDefault: LoadingCtxType = {
  loading: false,
  setLoadingStatus: () => {},
};

const LoadingContext = createContext<LoadingCtxType>(loadindDefault);

const LoadingProvider = ({ children }: { children: React.ReactNode }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const setLoadingStatus = (param: boolean) => {
    setLoading(param);
  };

  return (
    <LoadingContext.Provider
      value={{
        loading,
        setLoadingStatus,
      }}
    >
      <span>{children}</span>
    </LoadingContext.Provider>
  );
};

const useLoading = () => {
  const context = useContext(LoadingContext);

  if (!context) throw new Error("useLoading must be used inside a `LoadingProvider`");
  return context;
};

export { LoadingProvider, useLoading };